// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authorization {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #212121; }
  .authorization__logo {
    width: 160px;
    height: 160px;
    margin-top: 53px; }
  .authorization__title {
    font-weight: 600;
    font-size: 24px; }
  .authorization__container {
    display: flex;
    flex-direction: column; }
    .authorization__container label {
      margin-top: 40px;
      margin-bottom: 6px; }
  .authorization__input {
    width: 480px;
    height: 51px;
    border: 1px solid #9e9e9e;
    border-radius: 4px;
    padding: 16px 13px;
    color: #212121;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
    .authorization__input:focus {
      border-color: #212121;
      outline: none; }
    @media screen and (max-width: 768px) {
      .authorization__input {
        width: 90vw; } }
  .authorization__button {
    margin: 0 auto;
    width: 260px;
    padding: 6px;
    margin-top: 59px;
    text-align: center;
    background: #fe6100;
    border-radius: 4px;
    color: #ffffff;
    border: none;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    transition: all 0.5s; }
    .authorization__button:hover {
      background: #833505; }
    @media screen and (max-width: 768px) {
      .authorization__button {
        width: 90vw; } }
  .authorization .disableButton {
    background: grey;
    pointer-events: none;
    cursor: default; }
  .authorization__error {
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: #db2820; }
    .authorization__error_response {
      margin: 0 auto;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #db2820; }
    .authorization__error_password {
      margin: 0 auto;
      font-weight: 400;
      font-size: 12px;
      line-height: 24px;
      color: #db2820; }
`, "",{"version":3,"sources":["webpack://./src/components/authorization/Authorization.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc,EAAA;EACd;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB,EAAA;EAElB;IACE,gBAAgB;IAChB,eAAe,EAAA;EAEjB;IACE,aAAa;IACb,sBAAsB,EAAA;IAFvB;MAIG,gBAAgB;MAChB,kBAAkB,EAAA;EAGtB;IACE,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;IATlB;MAWG,qBAAqB;MACrB,aAAa,EAAA;IAGf;MAfF;QAgBI,WAAW,EAAA,EAEd;EACD;IACE,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,oBAAoB,EAAA;IAbrB;MAeG,mBAAmB,EAAA;IAGrB;MAlBF;QAmBI,WAAW,EAAA,EAEd;EAhEH;IAkEI,gBAAgB;IAChB,oBAAoB;IACpB,eAAe,EAAA;EAEjB;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc,EAAA;IACd;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc,EAAA;IAEhB;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc,EAAA","sourcesContent":[".authorization {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #212121;\n  &__logo {\n    width: 160px;\n    height: 160px;\n    margin-top: 53px;\n  }\n  &__title {\n    font-weight: 600;\n    font-size: 24px;\n  }\n  &__container {\n    display: flex;\n    flex-direction: column;\n    label {\n      margin-top: 40px;\n      margin-bottom: 6px;\n    }\n  }\n  &__input {\n    width: 480px;\n    height: 51px;\n    border: 1px solid #9e9e9e;\n    border-radius: 4px;\n    padding: 16px 13px;\n    color: #212121;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    &:focus {\n      border-color: #212121;\n      outline: none;\n    }\n\n    @media screen and (max-width: 768px) {\n      width: 90vw;\n    }\n  }\n  &__button {\n    margin: 0 auto;\n    width: 260px;\n    padding: 6px;\n    margin-top: 59px;\n    text-align: center;\n    background: #fe6100;\n    border-radius: 4px;\n    color: #ffffff;\n    border: none;\n    font-size: 14px;\n    line-height: 24px;\n    cursor: pointer;\n    transition: all 0.5s;\n    &:hover {\n      background: #833505;\n    }\n\n    @media screen and (max-width: 768px) {\n      width: 90vw;\n    }\n  }\n  .disableButton {\n    background: grey;\n    pointer-events: none;\n    cursor: default;\n  }\n  &__error {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 24px;\n    color: #db2820;\n    &_response {\n      margin: 0 auto;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      color: #db2820;\n    }\n    &_password {\n      margin: 0 auto;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 24px;\n      color: #db2820;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
